import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import MediaIcon from './MediaIcon';

const Header = ({ t, setLang, lang }) => {
  const location = useLocation();
  const paths = ["/", "/projects", "/about-me"];
  const routeNames = { "/": "home", "/projects": "projects", "/about-me": "about" };

  const handleLanguageChange = (newLang) => {
    setLang(newLang);
  };

  return (
    <header className="header">
      <input className="hamburger" type="checkbox" aria-label="Menu" />

      <div className="media-header">
        <span className="media-header__line"></span>
        <div className="media-header__links">
          {["linkedin", "github", "email"].map((name) => (
            <MediaIcon key={name} name={name} />
          ))}
        </div>
      </div>

      <div className="container">
        <div className="header__inner">
          <Link className="logo" to="/">
            <img className="logo__img" src="/images/logo.svg" alt="Rajkumar logo" />
            <span className="logo__name">Rajkumar</span>
          </Link>
          <div className="header__links">
            {paths.map((path) => (
              <Link 
                key={path}
                to={path} 
                className={`header__link ${location.pathname === path ? "header__link_active" : ""}`}
              >
                {t[routeNames[path]]}
              </Link>
            ))}
          </div>
          <div className="dropdown">
            <span className="dropdown__label">{lang}</span>
            <div className="dropdown__list">
              {['en', 'ru', 'ua'].filter(l => l !== lang).map(langOption => (
                <div 
                  key={langOption}
                  className="dropdown__option"
                  onClick={() => handleLanguageChange(langOption)}
                >
                  {langOption}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;